export function CountryCodes() {
  const countryPrefixes = [
    { label: "Afghanistan (+93)", value: "+93" },
    { label: "Angola (+244)", value: "+244" },
    { label: "Albania (+355)", value: "+355" },
    { label: "Andorra (+376)", value: "+376" },
    { label: "UAE (+971)", value: "+971" },
    { label: "Argentina (+54)", value: "+54" },
    { label: "Armenia (+374)", value: "+374" },
    { label: "American Samoa (+1-684)", value: "+1-684" },
    { label: "Antigua & Barbuda (+1-268)", value: "+1-268" },
    { label: "Australia (+61)", value: "+61" },
    { label: "Austria (+43)", value: "+43" },
    { label: "Azerbaijan (+994)", value: "+994" },
    { label: "Burundi (+257)", value: "+257" },
    { label: "Belgium (+32)", value: "+32" },
    { label: "Benin (+229)", value: "+229" },
    { label: "Burkina Faso (+226)", value: "+226" },
    { label: "Bangladesh (+880)", value: "+880" },
    { label: "Bulgaria (+359)", value: "+359" },
    { label: "Bahrain (+973)", value: "+973" },
    { label: "Bahamas (+1-242)", value: "+1-242" },
    { label: "Bosnia (+387)", value: "+387" },
    { label: "Belarus (+375)", value: "+375" },
    { label: "Belize (+501)", value: "+501" },
    { label: "Bermuda (+1-441)", value: "+1-441" },
    { label: "Bolivia (+591)", value: "+591" },
    { label: "Brazil (+55)", value: "+55" },
    { label: "Barbados (+1-246)", value: "+1-246" },
    { label: "Brunei (+673)", value: "+673" },
    { label: "Bhutan (+975)", value: "+975" },
    { label: "Botswana (+267)", value: "+267" },
    { label: "CAR (+236)", value: "+236" },
    { label: "Canada (+1)", value: "+1" },
    { label: "Switzerland (+41)", value: "+41" },
    { label: "Chile (+56)", value: "+56" },
    { label: "China (+86)", value: "+86" },
    { label: "Cameroon (+237)", value: "+237" },
    { label: "Congo (+242)", value: "+242" },
    { label: "Colombia (+57)", value: "+57" },
    { label: "Comoros (+269)", value: "+269" },
    { label: "Cabo Verde (+238)", value: "+238" },
    { label: "Costa Rica (+506)", value: "+506" },
    { label: "Cuba (+53)", value: "+53" },
    { label: "Cyprus (+357)", value: "+357" },
    { label: "Czechia (+420)", value: "+420" },
    { label: "Germany (+49)", value: "+49" },
    { label: "Djibouti (+253)", value: "+253" },
    { label: "Dominica (+1-767)", value: "+1-767" },
    { label: "Denmark (+45)", value: "+45" },
    { label: "Dominican (+1-809)", value: "+1-809" },
    { label: "Algeria (+213)", value: "+213" },
    { label: "Ecuador (+593)", value: "+593" },
    { label: "Egypt (+20)", value: "+20" },
    { label: "Eritrea (+291)", value: "+291" },
    { label: "Spain (+34)", value: "+34" },
    { label: "Estonia (+372)", value: "+372" },
    { label: "Ethiopia (+251)", value: "+251" },
    { label: "Finland (+358)", value: "+358" },
    { label: "Fiji (+679)", value: "+679" },
    { label: "France (+33)", value: "+33" },
    { label: "Micronesia (+691)", value: "+691" },
    { label: "Gabon (+241)", value: "+241" },
    { label: "United Kingdom (+44)", value: "+44" },
    { label: "Georgia (+995)", value: "+995" },
    { label: "Ghana (+233)", value: "+233" },
    { label: "Gambia (+220)", value: "+220" },
    { label: "Guinea (+224)", value: "+224" },
    { label: "Guinea (+245)", value: "+245" },
    { label: "Equatorial Guinea (+240)", value: "+240" },
    { label: "Greece (+30)", value: "+30" },
    { label: "Grenada (+1-473)", value: "+1-473" },
    { label: "Guatemala (+502)", value: "+502" },
    { label: "Guyana (+592)", value: "+592" },
    { label: "Hong Kong (+852)", value: "+852" },
    { label: "Honduras (+504)", value: "+504" },
    { label: "Croatia (+385)", value: "+385" },
    { label: "Haiti (+509)", value: "+509" },
    { label: "Hungary (+36)", value: "+36" },
    { label: "Indonesia (+62)", value: "+62" },
    { label: "India (+91)", value: "+91" },
    { label: "Ireland (+353)", value: "+353" },
    { label: "Iran (+98)", value: "+98" },
    { label: "Iraq (+964)", value: "+964" },
    { label: "Iceland (+354)", value: "+354" },
    { label: "Israel (+972)", value: "+972" },
    { label: "Italy (+39)", value: "+39" },
    { label: "Jamaica (+1-876)", value: "+1-876" },
    { label: "Jordan (+962)", value: "+962" },
    { label: "Japan (+81)", value: "+81" },
    { label: "Kazakhstan (+7)", value: "+7" },
    { label: "Kenya (+254)", value: "+254" },
    { label: "Kyrgyzstan (+996)", value: "+996" },
    { label: "Cambodia (+855)", value: "+855" },
    { label: "Kiribati (+686)", value: "+686" },
    { label: "Saint Kitts (+1-869)", value: "+1-869" },
    { label: "South Korea (+82)", value: "+82" },
    { label: "Kuwait (+965)", value: "+965" },
    { label: "Lao (+856)", value: "+856" },
    { label: "Lebanon (+961)", value: "+961" },
    { label: "Liberia (+231)", value: "+231" },
    { label: "Libya (+218)", value: "+218" },
    { label: "Saint Lucia (+1-758)", value: "+1-758" },
    { label: "Liechtenstein (+423)", value: "+423" },
    { label: "Sri Lanka (+94)", value: "+94" },
    { label: "Lesotho (+266)", value: "+266" },
    { label: "Lithuania (+370)", value: "+370" },
    { label: "Luxembourg (+352)", value: "+352" },
    { label: "Latvia (+371)", value: "+371" },
    { label: "Macao (+853)", value: "+853" },
    { label: "Morocco (+212)", value: "+212" },
    { label: "Monaco (+377)", value: "+377" },
    { label: "Moldova (+373)", value: "+373" },
    { label: "Madagascar (+261)", value: "+261" },
    { label: "Maldives (+960)", value: "+960" },
    { label: "Mexico (+52)", value: "+52" },
    { label: "Marshall Islands (+692)", value: "+692" },
    { label: "Macedonia (+389)", value: "+389" },
    { label: "Mali (+223)", value: "+223" },
    { label: "Malta (+356)", value: "+356" },
    { label: "Myanmar (+95)", value: "+95" },
    { label: "Montenegro (+382)", value: "+382" },
    { label: "Mongolia (+976)", value: "+976" },
    { label: "Mozambique (+258)", value: "+258" },
    { label: "Mauritania (+222)", value: "+222" },
    { label: "Mauritius (+230)", value: "+230" },
    { label: "Malawi (+265)", value: "+265" },
    { label: "Malaysia (+60)", value: "+60" },
    { label: "Namibia (+264)", value: "+264" },
    { label: "Niger (+227)", value: "+227" },
    { label: "Nigeria (+234)", value: "+234" },
    { label: "Nicaragua (+505)", value: "+505" },
    { label: "Netherlands (+31)", value: "+31" },
    { label: "Norway (+47)", value: "+47" },
    { label: "Nepal (+977)", value: "+977" },
    { label: "Nauru (+674)", value: "+674" },
    { label: "New Zealand (+64)", value: "+64" },
    { label: "Oman (+968)", value: "+968" },
    { label: "Pakistan (+92)", value: "+92" },
    { label: "Panama (+507)", value: "+507" },
    { label: "Peru (+51)", value: "+51" },
    { label: "Philippines (+63)", value: "+63" },
    { label: "Palau (+680)", value: "+680" },
    { label: "Papua New Guinea (+675)", value: "+675" },
    { label: "Poland (+48)", value: "+48" },
    { label: "North Korea (+850)", value: "+850" },
    { label: "Portugal (+351)", value: "+351" },
    { label: "Paraguay (+595)", value: "+595" },
    { label: "Qatar (+974)", value: "+974" },
    { label: "Romania (+40)", value: "+40" },
    { label: "Russia (+7)", value: "+7" },
    { label: "Rwanda (+250)", value: "+250" },
    { label: "Saudi Arabia (+966)", value: "+966" },
    { label: "Sudan (+249)", value: "+249" },
    { label: "Senegal (+221)", value: "+221" },
    { label: "Singapore (+65)", value: "+65" },
    { label: "Solomon Islands (+677)", value: "+677" },
    { label: "Sierra Leone (+232)", value: "+232" },
    { label: "El Salvador (+503)", value: "+503" },
    { label: "San Marino (+378)", value: "+378" },
    { label: "Somalia (+252)", value: "+252" },
    { label: "Serbia (+381)", value: "+381" },
    { label: "Sao Tome (+239)", value: "+239" },
    { label: "Suriname (+597)", value: "+597" },
    { label: "Slovakia (+421)", value: "+421" },
    { label: "Slovenia (+386)", value: "+386" },
    { label: "Sweden (+46)", value: "+46" },
    { label: "Eswatini (+268)", value: "+268" },
    { label: "Seychelles (+248)", value: "+248" },
    { label: "Syria (+963)", value: "+963" },
    { label: "Chad (+235)", value: "+235" },
    { label: "Togo (+228)", value: "+228" },
    { label: "Thailand (+66)", value: "+66" },
    { label: "Tajikistan (+992)", value: "+992" },
    { label: "Turkmenistan (+993)", value: "+993" },
    { label: "Timor-Leste (+670)", value: "+670" },
    { label: "Tonga (+676)", value: "+676" },
    { label: "Trinidad & Tobago (+1-868)", value: "+1-868" },
    { label: "Tunisia (+216)", value: "+216" },
    { label: "Türkiye (+90)", value: "+90" },
    { label: "Tuvalu (+688)", value: "+688" },
    { label: "Taiwan (+886)", value: "+886" },
    { label: "Tanzania (+255)", value: "+255" },
    { label: "Uganda (+256)", value: "+256" },
    { label: "Ukraine (+380)", value: "+380" },
    { label: "Uruguay (+598)", value: "+598" },
    { label: "United States (+1)", value: "+1" },
    { label: "Uzbekistan (+998)", value: "+998" },
    { label: "Vatican City (+379)", value: "+379" },
    { label: "Saint Vincent (+1-784)", value: "+1-784" },
    { label: "Venezuela (+58)", value: "+58" },
    { label: "Vietnam (+84)", value: "+84" },
    { label: "Vanuatu (+678)", value: "+678" },
    { label: "Samoa (+685)", value: "+685" },
    { label: "Yemen (+967)", value: "+967" },
    { label: "South Africa (+27)", value: "+27" },
    { label: "Zambia (+260)", value: "+260" },
    { label: "Zimbabwe (+263)", value: "+263" },
  ].sort((a, b) => a.label.localeCompare(b.label));

  return (
    <>
      {countryPrefixes.map((code) => (
        <option key={code.label} value={code.value}>
          {code.label}
        </option>
      ))}
    </>
  );
}

export function TelexCodes() {
  const telexPrefixes = [
    { label: "Argentina (33)", value: "33" },
    { label: "Belgium (46)", value: "46" },
    { label: "Canada (21)", value: "21" },
    { label: "China (85)", value: "85" },
    { label: "France (42)", value: "42" },
    { label: "Germany (41)", value: "41" },
    { label: "India (79)", value: "79" },
    { label: "Italy (43)", value: "43" },
    { label: "Japan (72)", value: "72" },
    { label: "Netherlands (44)", value: "44" },
    { label: "Russia (65)", value: "65" },
    { label: "Spain (52)", value: "52" },
    { label: "Sweden (54)", value: "54" },
    { label: "United Kingdom (51)", value: "51" },
    { label: "United States (23)", value: "23" },
  ].sort((a, b) => a.label.localeCompare(b.label));

  return (
    <>
      {telexPrefixes.map((code) => (
        <option key={code.label} value={code.value}>
          {code.label}
        </option>
      ))}
    </>
  );
}

export function InmarsatTelexCodes() {
  const inmarsatOptions = [
    { label: "Inmarsat Atlantic East (581)", value: "581" },
    { label: "Inmarsat Pacific (582)", value: "582" },
    { label: "Inmarsat Indian Ocean (583)", value: "583" },
    { label: "Inmarsat Atlantic West (584)", value: "584" },
    { label: "Inmarsat Sat C (58*4)", value: "58*4" },
  ];

  return (
    <>
      {inmarsatOptions.map(({ label, value }) => (
        <option key={label} value={value}>
          {label}
        </option>
      ))}
    </>
  );
}

export function InmarsatSatelliteCodes() {
  const oceanRegionOptions = [
    { label: "Global (+870)", value: "+870" },
    { label: "Atlantic Ocean East (+871)", value: "+871" },
    { label: "Pacific Ocean (+872)", value: "+872" },
    { label: "Indian Ocean (+873)", value: "+873" },
    { label: "Atlantic Ocean West (+874)", value: "+874" },
  ];

  return (
    <>
      {oceanRegionOptions.map(({ label, value }) => (
        <option key={label} value={value}>
          {label}
        </option>
      ))}
    </>
  );
}

export function IridiumSatelliteCodes() {
  return (
    <>
      <option value="+8816">+8816</option>
      <option value="+8817">+8817</option>
    </>
  );
}

export function ThurayaSatelliteCodes() {
  return (
    <>
      <option value="+88216">+88216</option>
    </>
  );
}

export function GlobalStarSatelliteCodes() {
  return (
    <>
      <option value="+8818">+8818</option>
      <option value="+8819">+8819</option>
    </>
  );
}
